<h1 mat-dialog-title *ngIf="data.edit == true">Edit Question</h1>
<h1 mat-dialog-title *ngIf="data.edit != true">Add Question</h1>

<div mat-dialog-content>

  <mat-form-field class="example-full-width">
    <mat-label>Title</mat-label>
    <input style="min-width: 100%;" matInput  type="text"  placeholder="Title" [(ngModel)]="Title">
  </mat-form-field>

  <mat-form-field class="example-full-width">
    <mat-label>Question Type</mat-label>
    <mat-select (selectionChange)="changeQuestionType($event.value)" [(ngModel)]="QuestionTypeid">
      <mat-option *ngFor="let ques of QuestionsTypes" [value]="ques.Id">
        {{ques.Title}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="example-full-width">
    <mat-label>Slide</mat-label>
    <mat-select (selectionChange)="changeInductionSlide($event.value)" [(ngModel)]="SlideID">
      <mat-option *ngFor="let slide of inductionSlides" [value]="slide.ID">
        {{slide.Title}}
      </mat-option>
    </mat-select>
  </mat-form-field>

</div>
<div mat-dialog-actions class="dialogControllBtn">
  <a class="button button--primary" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
  <button style="margin-left: 20px;" class="button button--primary" (click)="onSubmitClick()"
    [disabled]="Title == null ||  QuestionTypeid == null || SlideID == null ">
    <span class="button__text">Submit</span>
  </button>

</div>